import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/layout/Layout';
import Dashboard from './pages/Dashboard';
import Login from './pages/Login';
import Register from './pages/Register';
import ResetPassword from './pages/ResetPassword';
import Shipments from './pages/Shipments';
import CreateShipment from './pages/CreateShipment';
import ShipmentDetail from './pages/ShipmentDetail';
import Reports from './pages/Reports';
import Support from './pages/Support';
import Profile from './pages/Profile';
import LocationManagement from './pages/LocationManagement';
import Quotes from './pages/Quotes';
import OrganizationSettings from './pages/OrganizationSettings';
export function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  // Mock authentication for demo purposes
  const handleLogin = () => {
    setIsAuthenticated(true);
  };
  const handleLogout = () => {
    setIsAuthenticated(false);
  };
  return <Router data-id="element-0">
      <Routes data-id="element-1">
        {/* Auth Routes */}
        <Route path="/login" element={!isAuthenticated ? <Login onLogin={handleLogin} data-id="element-3" /> : <Navigate to="/dashboard" replace data-id="element-4" />} data-id="element-2" />
        <Route path="/register" element={!isAuthenticated ? <Register data-id="element-6" /> : <Navigate to="/dashboard" replace data-id="element-7" />} data-id="element-5" />
        <Route path="/reset-password" element={<ResetPassword data-id="element-9" />} data-id="element-8" />
        {/* Protected Routes */}
        <Route path="/" element={isAuthenticated ? <Layout onLogout={handleLogout} data-id="element-11" /> : <Navigate to="/login" replace data-id="element-12" />} data-id="element-10">
          <Route index element={<Navigate to="/dashboard" replace data-id="element-14" />} data-id="element-13" />
          <Route path="dashboard" element={<Dashboard data-id="element-16" />} data-id="element-15" />
          <Route path="shipments" element={<Shipments data-id="element-18" />} data-id="element-17" />
          <Route path="shipments/create" element={<CreateShipment data-id="element-20" />} data-id="element-19" />
          <Route path="shipments/:id" element={<ShipmentDetail data-id="element-22" />} data-id="element-21" />
          <Route path="locations" element={<LocationManagement data-id="element-24" />} data-id="element-23" />
          <Route path="quotes" element={<Quotes data-id="element-26" />} data-id="element-25" />
          <Route path="reports" element={<Reports data-id="element-28" />} data-id="element-27" />
          <Route path="support" element={<Support data-id="element-30" />} data-id="element-29" />
          <Route path="organization" element={<OrganizationSettings data-id="element-32" />} data-id="element-31" />
          <Route path="profile" element={<Profile data-id="element-34" />} data-id="element-33" />
        </Route>
      </Routes>
    </Router>;
}